import { NgModule } from '@angular/core';
import { BrainWebchatComponent } from './brain-webchat.component';

@NgModule({
  exports: [BrainWebchatComponent],
  imports: [BrainWebchatComponent],
})
export class BrainWebchatModule {}
